export default __webpack_public_path__ + "static/media/landscape_right_side.6102ab71.jpg";